// src/api/anomaly.js
// API utility for Anomaly Engine

export async function getAnomalyScore() {
  const response = await fetch("/anomaly/score");
  if (!response.ok) {
    throw new Error(`Failed to fetch anomaly score: ${response.status}`);
  }
  return response.json();
}

export async function getAnomalyMode() {
  const response = await fetch("/anomaly/mode");
  if (!response.ok) {
    throw new Error(`Failed to fetch anomaly mode: ${response.status}`);
  }
  return response.json();
}

export async function getAnomalyWeights() {
  const response = await fetch("/anomaly/weights");
  if (!response.ok) {
    throw new Error(`Failed to fetch anomaly weights: ${response.status}`);
  }
  return response.json();
}
